export default {
  'header': {
    'hideMenuBar': 'Ocultar la barra de menu',
    'showMenuBar': 'Mostrar la barra de menu'
  }
}
